module.exports = __webpack_public_path__ + "img/tghd_img_bx4.6d2829b4.png";